import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

export const volumeTooHigh = (tj: Partial<TherapyJobV2>, deviationPercentage: number) => {
  const isRunning = tj?.status === TherapyJobStatus.RUNNING;

  return isVolumeTooHigh(tj, deviationPercentage) && isRunning;
};

// we will use this to show volume information in completed cards
export const isVolumeTooHigh = (tj: Partial<TherapyJobV2>, deviationPercentage: number): boolean => {
  if (deviationPercentage === null || deviationPercentage === undefined) {
    console.warn('No deviation volume percentage configured, skipping volume check for job: ', tj?.id);
    return false;
  }

  const injectedVolume = tj?.therapyJobProgress?.injectedVolume || Number.MIN_SAFE_INTEGER;
  const totalVolume = tj?.totalVolumeEdited || tj?.totalVolumePrescribed || Number.MAX_SAFE_INTEGER;

  const totalVolumeDeviation = totalVolume * (deviationPercentage / 100);
  const isTooHigh = injectedVolume > totalVolume + totalVolumeDeviation;

  return isTooHigh;
};
